export default (labels) => {
    return labels.filter((label) => {
        const isLabel = label.label ? true : false
        return isLabel;
    })
}







// WEBPACK FOOTER //
// ./src/selectors/labels.js